<template>
  <el-dialog
    title="我的证书"
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    width="600px"
    center
    :show-close="true"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    class="certificate-dialog"
  >
    <div class="certificate-content">
      <div class="certificate-image"></div>
      <div class="certificate-info">
        <div class="info-item">
          <span class="info-label">证书名称：</span>
          <span class="info-value">{{ certificateName }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">证书编号：</span>
          <span class="info-value">{{ certificateNumber }}</span>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleDownload">下载证书</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'CertificateDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    certificateName: {
      type: String,
      default: ''
    },
    certificateNumber: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleDownload() {
      // 处理证书下载逻辑
      this.$message.info('证书下载功能待实现')
    }
  }
}
</script>

<style scoped lang="scss">
.certificate-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #ebeef5;
    padding: 20px 20px 10px;
  }
  
  .el-dialog__title {
    text-align: center;
    font-weight: bold;
  }
  
  .el-dialog__body {
    padding: 30px 20px;
  }
}

.certificate-content {
  text-align: center;
}

.certificate-image {
  width: 400px;
  height: 250px;
  background-color: #4034eb;
  margin: 0 auto 20px;
  border-radius: 4px;
}

.certificate-info {
  margin-top: 20px;
  text-align: center;
}

.info-item {
  margin-bottom: 10px;
  font-size: 16px;
  color: #333;
}

.info-label {
  color: #606266;
  margin-right: 10px;
}

.info-value {
  font-weight: 500;
  color: #333;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}

.dialog-footer .el-button--primary {
  background-color: #4034eb;
  border-color: #4034eb;
  padding: 10px 30px;
  font-size: 16px;
}
</style>